import { useState } from 'react';
import { Box } from '@mui/material';
import { useLanguage } from 'context/AppContext';
import Button from './Button';
import theme from 'App.theme';
import useVersionCheck from 'hooks/useVersionCheck';

const VersionUpdateBanner = ({ appVersion }: { appVersion: string }) => {
  const lang = useLanguage()[0].VersionUpdateBanner;

  const [dismissed, setDismissed] = useState(false);

  const newVersion = useVersionCheck(appVersion);

  const handleReload = () => {
    window.location.reload();
  };

  return dismissed || !newVersion ? null : (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        backgroundColor: theme.colors.transYellow,
        p: theme.layout.spacing.medium,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.layout.spacing.small,
        zIndex: theme.layers.top,
      }}
    >
      <Box>
        {lang.newVersionAvailable.replace('{currentVersion}', appVersion).replace('{latestVersion}', newVersion)}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: theme.layout.spacing.small }}>
        <Button colors="white on primary" onClick={handleReload} sx={{ justifySelf: 'center' }}>
          {lang.reloadPage}
        </Button>
        <Button colors="white on red" onClick={() => setDismissed(true)} sx={{ justifySelf: 'center' }}>
          {lang.dismissForNow}
        </Button>
      </Box>
    </Box>
  );
};

export default VersionUpdateBanner;
